import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IServerSideGetRowsRequest } from 'ag-grid-community';

export interface GridPageResponse<T> {
  rows: T[];
  totalCount: number;
}

@Injectable({
  providedIn: 'root'
})

export class TechnicianManagerService {
  private readonly techniciansEndpoint = '/api/contacts/technicians.php';

  constructor(private http: HttpClient) { }

  getTechnicians(request: IServerSideGetRowsRequest){
    return this.http.post<any>(this.techniciansEndpoint, request);
  }

  updateTechnicians(payload: {technician_uuid: string; field: string; value: unknown}){
    return this.http.post<any>(this.techniciansEndpoint, payload);
  }
}
